
import DialogTemplate from '@/_components/dialog/template/template.vue'
import { postRequest } from '@/plugins/api-axios'
import CompanyTreeX from '@/views/Project/ch/components/companyTreeX.vue'
import Contractors from '@/views/Project/ch/components/contractors.vue'
import ProjectMixin from '@/_mixins/project'
import RiskLevelMixin from '../mixins/risk.mixin'
import StartBankIcon from './startBankIcon.vue'
import { deserialise } from 'kitsu-core'

export default {
    name: 'ContractorRolesDialog',
    mixins: [ProjectMixin, RiskLevelMixin],
    components: {
        Contractors,
        CompanyTreeX,
        DialogTemplate,
        StartBankIcon,
    },
    props: {
        props: Object,
    },
    provide: {
        hierarchyProvider: {},
    },
    data() {
        return {
            tree: [] as any[],
            isLoading: false,
            isImporting: false,
        }
    },
    methods: {
        async handleImport() {
            try {
                this.isImporting = true
                await postRequest(
                    this.getURL({
                        path: `contractorHierarchies/${this.props.hierarchyId}/importFromBklr`,
                        base: this.contractorBaseUrl,
                    }),
                    {}
                )
                this.$emit('close', true)
            } finally {
                this.isImporting = false
            }
        },
    },
    async created() {
        try {
            this.isLoading = true

            const hierarchyResponse = await postRequest(
                this.getURL({
                    path: `contractorHierarchies/${this.props.hierarchyId}/importFromBklr`,
                    base: this.contractorBaseUrl,
                    params: {
                        dryRun: true,
                        skipLinks: '',
                        include:
                            'nodes,nodes.parent,nodes.company,nodes.companyDetails,nodes.companyDetails.contacts,nodes.companyDetails.documents',
                    },
                }),
                {}
            )

            let hierarchyData = deserialise(hierarchyResponse.data)
            let ids = {}
            let companyDetails = {}
            hierarchyData.data.nodes.data.forEach((node) => {
                ids[node.id] = { ...node, children: [] }
                if (node.companyDetails?.data?.id) {
                    companyDetails[node.companyDetails.data.id] = node.id
                }
            })
            hierarchyData.data.nodes.data.forEach((node) => {
                const addingNode = ids[node.id]
                addingNode._isMatch = !node.isArchived
                if (!node.parent.data) {
                    if (!this.tree) this.tree = []
                    this.tree.push(addingNode)
                } else {
                    ids[node.parent.data.id].children.push(addingNode)
                    ids[node.parent.data.id].children.sort((a, b) => a.index - b.index)
                }
            })
        } catch (e) {
            console.error(e)
        } finally {
            this.isLoading = false
        }
    },
}
